import { theme } from 'aimo-ui';
import Icon from 'components/icons/Icon';
import React from 'react';
import styled from 'styled-components/native';
import tinycolor from 'tinycolor2';
import { SizeProps } from 'types/IconTypes';
import { colors, vehicleIcons } from '../onboarding/vehicleSettings';

const defaultIcon = vehicleIcons[0];
const defaultColor = colors[0];

const VehicleAvatarWrapper = styled.View<{
  numericSize: number;
}>`
  height: ${({ numericSize }) => numericSize + numericSize / 2}px;
  width: ${({ numericSize }) => numericSize + numericSize / 2}px;
  align-self: center;
  align-items: center;
  justify-content: center;
`;

export const VehicleIconWrapper = styled.View<{
  color: string;
  numericSize: number;
  showBackground: boolean;
  showBorder: boolean;
}>`
  height: ${({ numericSize }) => numericSize + numericSize / 3}px;
  width: ${({ numericSize }) => numericSize + numericSize / 3}px;
  ${(props) =>
    props.showBackground ? `background-color: ${props.color};` : undefined}
  border-radius: 40px;
  align-self: center;
  align-items: center;
  justify-content: center;
  ${(props) => border(props.color, props.showBorder)}
`;

const VehicleLowEmissionWrapper = styled.View`
  position: absolute;
  right: 0px;
  top: 0px;
`;

const border = (color: string, showBorder: boolean) => {
  if (!showBorder) {
    return undefined;
  }
  return `border: 2px solid
  ${color === '#FFFFFF' ? '#D6DFE3' : '#FFFFFF'};`;
};

type VehicleAvatarProps = {
  color?: string | null;
  icon?: string | null;
  size?: string;
  showLowEmission?: boolean;
  showBackground?: boolean;
  showBorder?: boolean;
  isLowEmission?: boolean;
};

const lowEmissionSize = (size: string) => {
  const sizes: SizeProps = theme.iconSizes;
  const sizeArray = Object.keys(sizes);

  return sizeArray[sizeArray.indexOf(size) - 2] ?? 'xs';
};

const VehicleAvatar = ({
  color,
  icon,
  size = 'm',
  showLowEmission = true,
  showBackground = true,
  showBorder = true,
  isLowEmission = false,
}: VehicleAvatarProps) => {
  const sizes: SizeProps = theme.iconSizes;
  const numericSize = sizes[size];

  return (
    <VehicleAvatarWrapper numericSize={numericSize}>
      <VehicleIconWrapper
        numericSize={numericSize}
        color={color || defaultColor}
        showBackground={showBackground}
        showBorder={showBorder}>
        <Icon
          name={icon || defaultIcon}
          size={size}
          color={
            tinycolor(color || defaultColor).isLight()
              ? theme.colors.black
              : theme.colors.white
          }
          testID={`vehicle-avatar-${color ?? defaultColor}-${
            icon || defaultIcon
          }`}
        />
      </VehicleIconWrapper>
      {showLowEmission && isLowEmission && (
        <VehicleLowEmissionWrapper>
          <Icon
            name="Leaf-contour"
            size={lowEmissionSize(size)}
            color={
              tinycolor(color ?? defaultColor).isLight()
                ? theme.colors.black
                : theme.colors.white
            }
            testID={`vehicle-low-emission-${color ?? defaultColor}-${
              icon ?? defaultIcon
            }`}
          />
        </VehicleLowEmissionWrapper>
      )}
    </VehicleAvatarWrapper>
  );
};

export default VehicleAvatar;
